<div class="card card-sm border box-shadow-sm h-100">
  <div class="card-body">

    <div class="mb-3">
		<ng-content select="[icon]"></ng-content>
    </div>

    <h4 class="mb-2">{{ headline }}</h4>

    <p class="card-text mb-0">
      <ng-content></ng-content>
    </p>
  </div>
</div>
